export default __webpack_public_path__ + "static/media/uploader-abbottLite-3.b4b75560.png";